import useUser from "~/contexts/user";
import { useFliptBooleanLowercase } from "~/hooks/useFliptBooleanLowercase";

export const useDatasetAssistant = (): boolean => {
  const user = useUser();
  return useFliptBooleanLowercase("dataset-chat-agent", false, user?.email);
};

export default useDatasetAssistant;
